import * as React from "react";
import { SVGProps, memo } from "react";

const SvgRotation = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4 10.2H6a.6.6 0 0 0-.6.6v8.4a.6.6 0 0 0 .6.6h8.4a.6.6 0 0 0 .6-.6v-8.4a.6.6 0 0 0-.6-.6ZM6 8.4a2.4 2.4 0 0 0-2.4 2.4v8.4A2.4 2.4 0 0 0 6 21.6h8.4a2.4 2.4 0 0 0 2.4-2.4v-8.4a2.4 2.4 0 0 0-2.4-2.4H6Z"
      fill="#2BA168"
    />

    <path
      d="M15.41 4.167v1.212a.6.6 0 0 1-.868.537l-4.538-2.27a.6.6 0 0 1 0-1.072l4.538-2.27a.6.6 0 0 1 .869.537V2.29a9.554 9.554 0 0 1 4.335 2.494 9.569 9.569 0 0 1 2.81 6.787h-1.8a7.774 7.774 0 0 0-2.283-5.514 7.766 7.766 0 0 0-3.062-1.89Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgRotation);

export default Memo;
